import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { gsap } from 'gsap';
import { LanguageService } from '../language.service';

@Component({
    selector: 'app-cv',
    templateUrl: './cv.component.html',
    styleUrls: ['./cv.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CvComponent implements OnInit, AfterViewInit, OnDestroy {
  private animationContext?: gsap.Context;

  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    public readonly language: LanguageService,
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.animationContext = gsap.context(() => {
      gsap.timeline({ defaults: { ease: 'power3.out' } })
        .from('.artist-name', { autoAlpha: 0, y: 28, duration: .8, stagger: .12 })
        .from('.artist-role', { autoAlpha: 0, x: 22, duration: .65 }, '-=.35');
    }, this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.animationContext?.revert();
  }
}
